import { ShoptetCell } from '@/components/druhaJakost/ShoptetCell';
import { type Zalozena, fmtDateTime } from '@/lib/druhaJakost';

/** Seznam „Naposledy založené" — 2. jakosti v Tools a jejich stav v Shoptetu CZ. */
export function ZalozeneTabulka({
  items,
  listError,
  onDone,
}: {
  items: Zalozena[];
  listError: string;
  onDone: (msg: string, ok: boolean) => void;
}) {
  return (
    <>
      <h2 className="text-lg font-bold text-text mb-3">Naposledy založené</h2>
      {listError && <p className="text-sm text-danger">{listError}</p>}
      {!listError && items.length === 0 && (
        <p className="text-sm text-text-muted">Zatím žádná 2. jakost založená tady.</p>
      )}
      {items.length > 0 && (
        <div className="bg-surface rounded-xl shadow-card overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-border text-left text-xs uppercase tracking-wider text-text-muted">
                <th className="px-4 py-3">Kód</th>
                <th className="px-4 py-3">Název</th>
                <th className="px-4 py-3">Originál</th>
                <th className="px-4 py-3">Shoptet CZ</th>
                <th className="px-4 py-3">Založil</th>
                <th className="px-4 py-3">Kdy</th>
              </tr>
            </thead>
            <tbody>
              {items.map((i) => (
                <tr key={i.new_code} className="border-b border-border-light">
                  <td className="px-4 py-2 font-mono font-semibold text-text">{i.new_code}</td>
                  <td className="px-4 py-2 text-text">{i.new_name ?? '—'}</td>
                  <td className="px-4 py-2 text-text-secondary">
                    <span className="font-mono">{i.original_code}</span>
                    {i.original_eshop && (
                      <span className="block text-xs text-text-muted max-w-56 truncate">
                        {i.original_eshop.url ? (
                          <a
                            href={i.original_eshop.url}
                            target="_blank"
                            rel="noreferrer"
                            className="underline hover:text-text"
                            title={i.original_eshop.name}
                          >
                            {i.original_eshop.name}
                          </a>
                        ) : (
                          i.original_eshop.name
                        )}
                      </span>
                    )}
                  </td>
                  <td className="px-4 py-2">
                    <ShoptetCell item={i} onDone={onDone} />
                  </td>
                  <td className="px-4 py-2 text-text-secondary">{i.created_by}</td>
                  <td className="px-4 py-2 text-text-secondary whitespace-nowrap">
                    {fmtDateTime(i.created_at)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
